import React from "react";

import { useTranslation } from "react-i18next";

import Logo from "../img/Logo.svg";
import AmgenWhite from "../img/Amgen-white.svg";
import DownArrows from "../img/down-arrows.svg";
import background from "../../images/background.svg";
import oldBackground from "../../images/old-background.svg";

import "./index.css";

export default function StartScreen(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");
  const branding = props.sceneData.Scrolly.branding;

  const title = t(`${props.sceneData.Scrolly.title}.string`);
  document.title = `LabXchange | ${title.includes(".string") ? props.sceneData.Scrolly.title_en : title}`;

  return (
    <div
      role="banner"
      id="start-screen"
      className="start-screen"
      aria-hidden={props.ariaHideSplashScreens === "start" ? false : true}
      style={{
        backgroundImage: props.sceneData.Scrolly.background
          ? `url(${background})`
          : `url(${oldBackground})`,
      }}
    >
      <div
        className={`${props.bp === "lg" || props.bp === "xl" ? "start-branding-desktop" : "start-branding-mobile"}`}
      >
        <img
          alt={
            branding === "Amgen"
              ? t("amgenLogoAlt.string")
              : t("logoAlt.string")
          }
          src={branding === "Amgen" ? AmgenWhite : Logo}
          className={`start-logo-2 ${props.bp === "lg" || props.bp === "xl" ? "start-logo-2-desktop" : "start-logo-2-mobile"} ${branding === "" ? (props.bp === "lg" || props.bp === "xl" ? "start-solo-logo-desktop" : "start-solo-logo-mobile") : ""}`}
        />
        {branding !== "" && (props.bp === "lg" || props.bp === "xl") ? (
          <div className="logo-line"></div>
        ) : null}
        {branding !== "" ? (
          <img
            alt={t("logoAlt.string")}
            src={Logo}
            className={`start-logo ${props.bp === "lg" || props.bp === "xl" ? "start-logo-desktop" : "start-logo-mobile"}`}
          />
        ) : null}
      </div>
      <h1
        style={{
          fontSize:
            props.bp !== "md" && props.bp !== "lg" && props.bp !== "xl"
              ? "24px"
              : null,
        }}
        className="start-title"
      >
        {title.includes(".string") ? props.sceneData.Scrolly.title_en : title}
      </h1>
      <div className="start-action">
        <p className="scro-call-to-action">
          {!props.animationReady
            ? `${t("loading.string")}...`
            : t("callToAction.string")}
        </p>
        <img alt="" className="start-arrows" src={DownArrows} />
        <p className="scro-start-intro">{t("introduction.string")}</p>
      </div>
    </div>
  );
}
